import { Route, Routes } from "react-router-dom";
import { PATHNAMES } from "@/shared";
import { LazyFallback } from "@/shared/ui/lazyFallback";
import { lazy } from "react";

const MainPage = lazy(() => import("@/pages/mainPage/MainPage"));
const LoginPage = lazy(() => import("@/pages/login/LoginPage"));
const UsersPage = lazy(() => import("@/pages/users/UsersPage"));
const DealersPage = lazy(() => import("@/pages/dealers/DealersPage"));
const NomenclaturePage = lazy(
  () => import("@/pages/nomenclature/NomenclaturePage"),
);
const OrdersPage = lazy(() => import("@/pages/orders/OrdersPage"));
const SettingsMainPage = lazy(
  () => import("@/pages/settings/SettingsMainPage"),
);
const SettingsSectionPage = lazy(
  () => import("@/pages/settings/SettingsSectionPage"),
);
const CartPage = lazy(() => import("@/pages/cart/CartPage"));
const ReportsPage = lazy(
  () => import("@/pages/reports/reportsMainPage/ReportsPage"),
);
const ReportDetailPage = lazy(
  () => import("@/pages/reports/reportDetailPage/ReportDetailPage"),
);
const FAQMainPage = lazy(() => import("@/pages/faq/FAQMainPage"));
const ArticlesPage = lazy(() => import("@/pages/articlesPage/ArticlesPage"));
const ArticleDetailPage = lazy(
  () => import("@/pages/articleDetailPage/ArticleDetailPage"),
);
const SearchResultPage = lazy(
  () => import("@/pages/searchResultPage/SearchResultPage"),
);
const CookiePage = lazy(() => import("@/pages/cookie/CookiePage"));
const Error404Page = lazy(() => import("@/pages/page404/Page404"));

const {
  cartPath,
  dealerPath,
  loginPath,
  nomenclaturePath,
  ordersPath,
  remainsPath,
  reportsPath,
  reportDraftPath,
  usersPath,
  recoveryPassPath,
  settingsPath,
  cookiePage,
  faqPath,
} = PATHNAMES;

const Layout = () => {
  return (
    <LazyFallback>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path={loginPath} element={<LoginPage />} />
        <Route path={recoveryPassPath} element={<LoginPage />} />
        <Route path={usersPath + "/*"} element={<UsersPage />} />
        <Route
          path={usersPath + "/" + dealerPath + "/:dealerId"}
          element={<DealersPage />}
        />
        <Route
          path={
            usersPath + "/" + dealerPath + "/:dealerId" + "/filials/:filialId"
          }
          element={<DealersPage />}
        />
        <Route
          path={nomenclaturePath}
          element={<NomenclaturePage productType="nomenclature" />}
        />
        <Route path={ordersPath} element={<OrdersPage />} />
        <Route
          path={remainsPath}
          element={<NomenclaturePage productType="remains" />}
        />
        <Route path={settingsPath} element={<SettingsMainPage />} />
        <Route
          path={`${settingsPath}/:section`}
          element={<SettingsSectionPage />}
        />
        <Route path={cartPath} element={<CartPage />} />
        <Route path={reportsPath} element={<ReportsPage />} />
        <Route
          path={`${reportsPath}/:reportId`}
          element={<ReportDetailPage />}
        />

        <Route
          path={`${reportDraftPath}/:reportId`}
          element={<ReportDetailPage isDraft={true} />}
        />
        <Route path={faqPath.root} element={<FAQMainPage type="dealer" />} />
        <Route path={faqPath.dealer} element={<FAQMainPage type="dealer" />} />
        <Route
          path={faqPath.manager}
          element={<FAQMainPage type="manager" />}
        />
        <Route
          path={`${faqPath.dealer}:section`}
          element={<ArticlesPage type="dealer" />}
        />
        <Route
          path={`${faqPath.manager}:section`}
          element={<ArticlesPage type="manager" />}
        />
        <Route
          path={`${faqPath.dealer}:section/:articleId`}
          element={<ArticleDetailPage type="dealer" />}
        />
        <Route
          path={`${faqPath.manager}:section/:articleId`}
          element={<ArticleDetailPage type="manager" />}
        />
        <Route
          path={faqPath.managerSearch}
          element={<SearchResultPage type="manager" />}
        />
        <Route
          path={faqPath.dealerSearch}
          element={<SearchResultPage type="dealer" />}
        />
        <Route path={cookiePage} element={<CookiePage />} />
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </LazyFallback>
  );
};

export default Layout;
